export default __webpack_public_path__ + "static/media/bti-icon.d11c56e5.webp";